<div class="sb-header">
  <h3>Components</h3>
</div>

<app-component-menu [connector]="connector" (openCompInfo)="onSelectComp($event)"></app-component-menu>